import Block from "./Block"
import styles from './BlockGroup.module.css'
import { useLanguage } from '../contexts/LanguageContext'

function BlockGroup({items}){
    const { language } = useLanguage()
    
    return ( 
        <div className={styles.BlockGroup}>
            {items.map((item, index) => (
                <Block 
                    key={index} 
                    entity="blocks" 
                    ob_id={item}
                    // Language is handled in Block component via context
                />
            ))}
        </div> 
    )
}

export default BlockGroup